/**
 * The order's shipping comment is one block of text. Line breaks stay inside
 * that single note. Pipes and blank lines are part of the comment, not separators.
 */

const decodeHtml = (value) => String(value || '')
    .replace(/&lt;br\s*\/?&gt;/gi, '\n')
    .replace(/&lt;\/(p|div|li|tr|h[1-6])&gt;/gi, '\n')
    .replace(/<br\s*\/?>/gi, '\n')
    .replace(/<\/(p|div|li|tr|h[1-6])>/gi, '\n')
    .replace(/<[^>]+>/g, '')
    .replace(/&nbsp;/gi, ' ')
    .replace(/&amp;/gi, '&')
    .replace(/&lt;/gi, '<')
    .replace(/&gt;/gi, '>')
    .replace(/&#39;|&apos;/gi, "'")
    .replace(/&quot;/gi, '"')
    .replace(/\r\n/g, '\n')
    .replace(/[ \t]+\n/g, '\n')
    .replace(/[ \t]{2,}/g, ' ')
    .replace(/\n{2,}/g, '\n')
    .trim();

export function toShippingCommentNotes(source) {
    const rawParts = Array.isArray(source) ? source : [source];
    const text = rawParts
        .map(decodeHtml)
        .filter((part) => part && part !== '-')
        .join('\n')
        .trim();
    if (!text) return [];
    return [{
        id: 'shipcomment-0',
        text,
        color: 'periwinkle',
        locked: true,
        source: 'shipping-comment',
    }];
}
